export const agencyProfile = {
  jobsPage: {
    title: { vi: "Danh sách Việc làm từ Việt Nam", bn: "ভিয়েতনাম থেকে চাকরির তালিকা" },
    desc: { vi: "Chúng tôi sẽ cập nhật thông tin việc làm sớm nhất, hãy kiểm tra thường xuyên để không bỏ lỡ các cơ hội cung ứng nhân lực mới nhất.", bn: "আমরা যত তাড়াতাড়ি সম্ভব চাকরির তথ্য আপডেট করব, সাম্প্রতিক জনশক্তি সরবরাহের cơ hộiগুলো মিস না করতে দয়া khuyên regular চেক করুন।" },
    syncing: { vi: "Hệ thống đang đồng bộ dữ liệu...", bn: "সিস্টেম তথ্য সিঙ্ক্রোনাইজ করছে..." },
    footerPrefix: { vi: "Nếu bạn có yêu cầu tuyển dụng đặc biệt, vui lòng liên hệ ", bn: "আপনার যদি বিশেষ নিয়োগের প্রয়োজন থাকে, তবে দয়া করে যোগাযোগ করুন " },
    masterAgent: { vi: "Đối tác chiến lược", bn: "মাস্টার এজেন্ট" },
    footerSuffix: { vi: " tại Dhaka.", bn: " ঢাকার সাথে।" }
  },
  masterAgentDialog: {
    role: { vi: "Đối tác chiến lược - Tổng đại lý", bn: "কৌশলগত অংশীদার - মাস্টার এজেন্ট" },
    contactInfo: { vi: "Thông tin liên hệ", bn: "যোগাযোগের তথ্য" },
    slogan: { vi: "\"Hợp tác tin cậy, kết nối bền vững vì tương lai lao động Bangladesh.\"", bn: "\"বাংলাদেশের জনশক্তির ভবিষ্যতের জন্য নির্ভরযোগ্য অংশীদারিত্ব এবং টেকসই সংযোগ।\"" },
    closeButton: { vi: "Đóng cửa sổ", bn: "উইন্ডো বন্ধ করুন" },
    confirm: { vi: "Xác nhận", bn: "নিশ্চিত করুন" },
    delete: { vi: "Xóa", bn: "মুছুন" },
    approvedLabel: { vi: "Đã phê duyệt", bn: "অনুমোদিত" },
    rejectedLabel: { vi: "Đã từ chối", bn: "প্রত্যাখ্যাত" },
    newRequest: { vi: "vừa đăng ký đối tác", bn: "একটি অংশীদারিত্বের জন্য নিবন্ধন করেছেন" },
    candidateConnect: { vi: "muốn kết nối với bạn", bn: "আপনার সাথে সংযোগ করতে চায়" },
    approvedByMaster: { vi: "Đối tác chiến lược - Tổng đại lý đã phê duyệt tư cách đối tác của bạn", bn: "কৌশলগত অংশীদার - মাস্টার এজেন্ট আপনার অংশীদারত্ব অনুমোদন করেছেন" },
    rejectedByMaster: { vi: "Đối tác chiến lược - Tổng đại lý từ chối yêu cầu đăng ký của bạn", bn: "কৌশলগত অংশীদার - মাস্টার এজেন্ট আপনার নিবন্ধনের অনুরোধ প্রত্যাখ্যান করেছেন" },
    approvedByAgent: { vi: "Đại lý đã chấp nhận kết nối với bạn", bn: "এজেন্ট আপনার সাথে সংযোগ গ্রহণ করেছেন" },
    rejectedByAgent: { vi: "Đại lý từ chối kết nối", bn: "এজেন্ট সংযোগ প্রত্যাখ্যান করেছেন" },
    reasonLabel: { vi: "Lý do", bn: "কারণ" }
  },
  profile: {
    title: { vi: "Hồ sơ đối tác", bn: "পার্টনার প্রোফাইল" },
    companyInfo: { vi: "Thông tin doanh nghiệp", bn: "কোম্পানি তথ্য" },
    capacityInfo: { vi: "Năng lực & Ngành nghề", bn: "ক্ষমতা এবং শিল্প" },
    leaderInfo: { vi: "Thông tin lãnh đạo", bn: "নেতৃত্বের তথ্য" },
    contactInfo: { vi: "Liên hệ chính thức", bn: "অফিসিয়াল যোগাযোগ" },
    documents: { vi: "Hồ sơ pháp lý", bn: "আইনি নথি" },
    officeGallery: { vi: "Thư viện ảnh văn phòng", bn: "অফিস ফটো গ্যালারি" },
    labels: {
      companyName: { vi: "Tên pháp nhân công ty", bn: "কোম্পানির নাম" },
      rlNumber: { vi: "Mã số thuế / Giấy phép kinh doanh", bn: "আরএল লাইসেন্স নম্বর" },
      established: { vi: "Năm thành lập", bn: "প্রতিষ্ঠিত বছর" },
      establishedYear: { vi: "Năm thành lập", bn: "প্রতিষ্ঠিত বছর" },
      tradeLicense: { vi: "Mã số doanh nghiệp", bn: "ট্রেড লাইসেন্স" },
      managingDirector: { vi: "Họ tên Giám đốc (MD/CEO)", bn: "ব্যবস্থাপনা পরিচালক" },
      representativeName: { vi: "Họ tên Giám đốc (MD/CEO)", bn: "ব্যবস্থাপনা পরিচালক" },
      mdPhone: { vi: "SĐT Giám đốc", bn: "পরিচালকের ফোন নম্বর" },
      officialPhone: { vi: "Số điện thoại Hotline", bn: "হটলাইন ফোন নম্বর" },
      officialEmail: { vi: "Email chính thức công ty", bn: "অফিসিয়াল ইমেল" },
      website: { vi: "Website", bn: "ওয়েবসাইট" },
      address: { vi: "Địa chỉ văn phòng tại Bangladesh", bn: "প্রধান কার্যালয়" },
      officeAddress: { vi: "Địa chỉ văn phòng tại Bangladesh", bn: "প্রধান কার্যালয়" },
      capacity: { vi: "Khả năng cung ứng (Người/tháng)", bn: "সরবরাহ ক্ষমতা" },
      industriesLabel: { vi: "Ngành nghề thế mạnh", bn: "প্রধান শিল্প" },
      mainIndustries: { vi: "Ngành nghề thế mạnh", bn: "প্রধান শিল্প" },
      managedJobs: { vi: "Việc làm đang quản lý", bn: "পরিচালিত চাকরি" },
      rlPhoto: { vi: "Ảnh giấy phép các loại", bn: "বিএমইটি লাইসেন্স এবং অন্যান্য লাইসেন্স" },
      changeBanner: { vi: "Thay đổi ảnh Banner chuyên nghiệp", bn: "ব্যানার ফটো পরিবর্তন করুন" },
      editProfile: { vi: "Chỉnh sửa hồ sơ", bn: "প্রোফাইল সংশোধন করুন" },
      sharePage: { vi: "Chia sẻ trang", bn: "পেজ শেয়ার করুন" },
      viewDocument: { vi: "Xem tài liệu", bn: "নথি দেখুন" },
      viewOffice: { vi: "Xem hình văn phòng", bn: "অফিস ফটো দেখুন" },
      viewGallery: { vi: "Xem bộ sưu tập", bn: "গ্যালারি দেখুন" },
      candidatesPerMonth: { vi: "Ứng viên / Tháng", bn: "প্রার্থী / মাস" },
      types: {
        master: { vi: "Đối tác chiến lược", bn: "মাস্টার অংশীদার" },
        agent: { vi: "Đại lý cấp 1", bn: "অংশীদার" }
      },
      industryTypes: {
        engineer: { vi: "Kỹ sư", bn: "ইঞ্জিনিয়ার" },
        construction: { vi: "Xây dựng", bn: "নির্মাণ" },
        nursing: { vi: "Điều dưỡng", bn: "নার্সিং" },
        garment: { vi: "May mặc", bn: "গার্মেন্টস" },
        manufacturing: { vi: "Sản xuất", bn: "উৎপাদন" }
      }
    },
    managedJobs: { vi: "Danh sách việc làm", bn: "পরিচালিত চাকরি" },
    jobsSection: {
      title: { vi: "Việc làm phụ trách", bn: "পরিচালিত চাকরি" },
      viewAll: { vi: "Xem tất cả", bn: "সব দেখুন" },
      empty: { vi: "Hiện tại bạn chưa đăng tuyển công việc nào.", bn: "বর্তমানে আপনি কোনো চাকরি পোস্ট করেননি।" }
    },
    loading: {
      title: { vi: "Đang tải hồ sơ...", bn: "প্রোফাইল লোড হচ্ছে..." },
      desc: { vi: "Vui lòng chờ trong giây lát", bn: "অনুগ্রহ করে কিছুক্ষণ অপেক্ষা করুন" }
    }
  },
  qrInvitation: {
    title: { vi: "Lan tỏa HelloJob", bn: "হ্যালোজব শেয়ার করুন" },
    enterpriseTab: { vi: "Doanh nghiệp", bn: "কোম্পানি" },
    agentTab: { vi: "Đại lý (CTV)", bn: "এজেন্ট" },
    enterpriseTitle: { vi: "Mời Doanh nghiệp tuyển dụng", bn: "কোম্পানি আমন্ত্রণ জানান" },
    agentTitle: { vi: "Mời Đại lý cộng tác", bn: "এজেন্ট আমন্ত্রণ জানান" },
    desc: {
      vi: "Quý đối tác có thể chia sẻ mã QR hoặc liên kết giới thiệu để mời các thành viên mới tham gia làm Đại lý cộng tác hoặc Doanh nghiệp có nhu cầu tuyển dụng lao động Bangladesh. Thành viên đăng ký qua mã này sẽ tự động gắn kết dưới quyền quản lý của bạn.",
      bn: "এজেন্ট আগ্রহী প্রার্থীদের কাছে QR কোডটি শুনতে বা লিঙ্কটি কপি করে পাঠাতে পারেন। এই কোড দিয়ে যুক্ত হলে তারা স্বয়ংক্রিয়ভাবে আপনার তালিকায় থাকবেন."
    },
    enterpriseDesc: {
      vi: "Mời các doanh nghiệp, nhà tuyển dụng tại Việt Nam có nhu cầu tuyển dụng lao động Bangladesh. Doanh nghiệp đăng ký qua mã này sẽ thuộc quyền quản lý và hỗ trợ trực tiếp từ bạn.",
      bn: "ভিয়েতনামের কোম্পানিগুলোকে আমন্ত্রণ জানান যারা বাংলাদেশ থেকে কর্মী নিয়োগ করতে চায়। তারা আপনার रेफरেলের মাধ্যমে যুক্ত হলে আপনার আওতাভুক্ত থাকবে।"
    },
    agentDesc: {
      vi: "Mời các cá nhân tham gia mạng lưới cung ứng với vai trò Đại lý cộng tác (CTV). Các thành viên này sẽ được gắn kết và hoạt động dưới sự hướng dẫn từ tài khoản Master của bạn.",
      bn: "নতুন অংশীদারদের (এজেন্ট) আমন্ত্রণ জানান যারা আপনার নেটওয়ার্কে যুক্ত হয়ে কাজ করতে আগ্রহী। তারা সরাসরি আপনার পরামর্শে পরিচালিত হবে।"
    },
    copyLink: { vi: "Sao chép Link", bn: "লিঙ্ক কপি" },
    copiedTitle: { vi: "Đã sao chép link", bn: "লিঙ্ক কপি হয়েছে" },
    copiedDesc: { vi: "Đã sao chép đường dẫn tải ứng dụng vào bộ nhớ tạm.", bn: "অ্যাপ ডাউনলোডের লিঙ্কটি ক্লিপবোর্ডে কপি করা হয়েছে।" },
    downloadQR: { vi: "Tải ảnh QR trắng", bn: "QR ছবি ডাউনলোড" },
    printPoster: { vi: "In Poster", bn: "প্রিন্ট পোস্টার" },
    selectSize: { vi: "Chọn khổ giấy", bn: "কাগজের সাইজ" },
    selectColor: { vi: "Màu nền", bn: "রঙ" },
    sizes: {
      a4: "A4",
      a3: "A3",
      a2: "A2",
      a1: "A1",
      a0: "A0"
    },
    themes: {
      light: { vi: "Nền sáng", bn: "লাইট মোড" },
      dark: { vi: "Nền tối", bn: "ডার্ক মোড" },
      orange: { vi: "Màu Cam", bn: "কমলা" },
      green: { vi: "Xanh lá", bn: "সবুজ" },
      blue: { vi: "Xanh dương", bn: "নীল" },
      lightBlue: { vi: "Xanh nhạt", bn: "হালকা নীল" }
    },
    viewHtml: { vi: "Xem trang HTML (Để in)", bn: "এইচটিএমএল পেজ দেখুন (প্রিন্টের জন্য)" },
    generating: { vi: "Đang tạo...", bn: "প্রস্তুত হচ্ছে..." },
    downloadSuccess: { vi: "Tải xuống thành công", bn: "ডাউনলোড সফল হয়েছে" },
    posterSuccess: { vi: "Poster khổ A3 đã được lưu về máy.", bn: "এ৩ পোস্টারটি আপনার ডিভাইসে সেভ করা হয়েছে।" },
    qrSuccess: { vi: "Mã QR đã được lưu vào máy.", bn: "QR কোডটি ডিভাইসে সেভ করা হয়েছে।" },
    errorTitle: { vi: "Lỗi hệ thống", bn: "সিস্টেম ত্রুটি" },
    errorDesc: { vi: "Không thể tải file lúc này.", bn: "এই মুহূর্তে ফাইল ডাউনলোড করা সম্ভব নয়।" },
    posterTemplateInfo: {
      title: { vi: "HelloJob Bangladesh", bn: "হ্যালোজব বাংলাদেশ" },
      subtitle: { vi: "Đối tác đại lý cấp 1", bn: "১ম শ্রেণীর অংশীদার এজেন্সি" },
      headline: { vi: "Tuyển dụng lao động\nkỹ thuật Bangladesh", bn: "ভিয়েতনামে\nনিশ্চিত ক্যারিয়ার গড়ুন" },
      roadmapTitle: { vi: "5 Bước Tuyển Dụng cùng HelloJob", bn: "হ্যালোজবের ৫ ধাপের রোডম্যাপ" },
      step1: { vi: "Đăng ký tài khoản doanh nghiệp", bn: "নিবন্ধন এবং ডিজিটাল প্রোফাইল তৈরি" },
      step2: { vi: "Đăng tải nhu cầu tuyển dụng", bn: "বিশ্বস্ত এজেন্সির সাথে সংযোগ করুন" },
      step3: { vi: "Phòng vấn trực tuyến qua Zoom", bn: "হাজার হাজার চাকরির সুযোগে এক্সেস" },
      step4: { vi: "Hoàn thiện Visa & Pháp lý", bn: "সরাসরি ভিডিও কলে ইন্টারভিউ দিন" },
      step5: { vi: "Tiếp nhận & Quản lý lao động", bn: "নিরাপদ প্রস্থান এবং কাজে যোগদান" },
      qrHeader: { vi: "Quét QR để mở Cánh cửa thành công!", bn: "QR কোড স্ক্যান করে নতুন দরজা খুলুন!" },
      qrDesc: { vi: "Mở ứng dụng Camera để thao tác cực tiết kiệm thời gian", bn: "অ্যাপ ডাউনলোড করতে ক্যামেরা দিয়ে স্ক্যান করুন" },
      agencyCodeLabel: { vi: "MÃ GIỚI THIỆU TỪ ĐẠI LÝ", bn: "রেফারেল কোড (এজেন্সি)" },
      darkMode: { vi: "Nền tối", bn: "ডার্ক মোড", en: "Dark Mode" },
      lightMode: { vi: "Nền sáng", bn: "লাইট মোড", en: "Light Mode" },
      selectBackground: { vi: "Chọn màu nền", bn: "ব্যাকগ্রাউন্ড কালার নির্বাচন করুন" }
    }
  },
  security: {
    menuLabel: { vi: "Bảo mật", bn: "নিরাপত্তা" },
    verificationBanner: {
      title: { vi: "Email của bạn chưa được xác thực", bn: "আপনার ইমেল এখনো যাচাই করা হয়নি" },
      desc: { vi: "Vui lòng kiểm tra hộp thư và nhấn vào liên kết xác nhận để bảo vệ tài khoản của bạn tốt hơn.", bn: "আপনার অ্যাকাউন্ট আরও ভালভাবে সুরক্ষিত করতে অনুগ্রহ করে আপনার ইনবক্স চেক করুন এবং নিশ্চিতকরণ লিঙ্কে ক্লিক করুন।" },
      resendBtn: { vi: "Gửi lại link xác nhận", bn: "যাচাইকরণ লিঙ্কটি পুনরায় পাঠান" },
      sending: { vi: "Đang gửi...", bn: "পাঠানো হচ্ছে..." },
      sentToast: { vi: "Đã gửi email xác nhận. Vui lòng kiểm tra hộp thư của bạn.", bn: "যাচাইকরণ ইমেল পাঠানো হয়েছে। অনুগ্রহ করে আপনার ইনবক্স চেক করুন।" }
    },
    dashboard: {
      title: { vi: "Cài đặt Bảo mật", bn: "নিরাপত্তা সেটিংস" },
      healthStatus: { vi: "Tình trạng bảo mật", bn: "নিরাপত্তার অবস্থা" },
      cards: {
        password: {
          title: { vi: "Mật khẩu đăng nhập", bn: "লগইন পাসওয়ার্ড" },
          desc: { vi: "Cập nhật mật khẩu thường xuyên giúp tài khoản của bạn an toàn hơn.", bn: "আপনার পাসওয়ার্ড নিয়মিত আপডেট করলে আপনার অ্যাকাউন্ট আরও সুরক্ষিত থাকে।" },
          status: { vi: "Đã thiết lập", bn: "সেট আপ করা আছে" }
        },
        social: {
          title: { vi: "Tài khoản liên kết", bn: "সংযুক্ত অ্যাকাউন্ট" },
          desc: { vi: "Quản lý các tài khoản Google, Facebook liên kết với HelloJob.", bn: "হ্যালোজবের সাথে যুক্ত গুগল, ফেসবুক অ্যাকাউন্টগুলি পরিচালনা করুন।" },
          status: { vi: "Sắp ra mắt", bn: "শীঘ্রই আসছে" }
        },
        mfa: {
          title: { vi: "Xác thực 2 lớp (MFA)", bn: "টু-ফ্যাক্টর অথেনটিকেশন" },
          desc: { vi: "Thêm một lớp bảo mật bằng số điện thoại hoặc app xác thực.", bn: "ফোন নম্বর বা অথেনটিকেটর অ্যাপ ব্যবহার করে নিরাপত্তার একটি অতিরিক্ত স্তর যুক্ত করুন।" },
          status: { vi: " Khuyên dùng", bn: "প্রস্তাবিত" }
        },
        sessions: {
          title: { vi: "Phiên đăng nhập", bn: "লগইন সেশন" },
          desc: { vi: "Kiểm tra và quản lý các thiết bị đang truy cập vào tài khoản.", bn: "অ্যাকাউন্ট অ্যাক্সেস করা ডিভাইসগুলো পরীক্ষা এবং পরিচালনা করুন।" },
          status: { vi: "An toàn", bn: "নিরাপদ" }
        }
      },
      manageBtn: { vi: "Quản lý", bn: "পরিচালনা করুন" }
    },
    sidebar: {
      overview: { vi: "Tổng quan", bn: "সারসংক্ষেপ" },
      password: { vi: "Đổi mật khẩu", bn: "পাসওয়ার্ড পরিবর্তন" },
      sessions: { vi: "Phiên đăng nhập", bn: "লগইন সেশন" },
      social: { vi: "Liên kết tài khoản", bn: "অ্যাকাউন্ট সংযোগ" },
      mfa: { vi: "Bảo mật 2 lớp", bn: "২-ফ্যাক্টর সিকিউরিটি" }
    },
    updatePassword: {
      title: { vi: "Đổi mật khẩu", bn: "পাসওয়ার্ড পরিবর্তন করুন" },
      subtitle: { vi: "Tạo mật khẩu mạnh để bảo vệ tài khoản Đại lý của bạn.", bn: "আপনার এজেন্সি অ্যাকাউন্ট সুরক্ষিত রাখতে একটি শক্তিশালী পাসওয়ার্ড তৈরি করুন।" },
      labels: {
        oldPassword: { vi: "Mật khẩu hiện tại", bn: "বর্তমান পাসওয়ার্ড" },
        newPassword: { vi: "Mật khẩu mới", bn: "নতুন পাসওয়ার্ড" },
        confirmPassword: { vi: "Xác nhận mật khẩu mới", bn: "নতুন পাসওয়ার্ড নিশ্চিত করুন" }
      },
      placeholders: {
        oldPassword: { vi: "Nhập mật khẩu hiện tại", bn: "বর্তমান পাসওয়ার্ড লিখুন" },
        newPassword: { vi: "Tối thiểu 6 ký tự", bn: "কমপক্ষে ৬ অক্ষরের হতে হবে" },
        confirmPassword: { vi: "Nhập lại mật khẩu mới", bn: "নতুন পাসওয়ার্ডটি lại লিখুন" }
      },
      validation: {
        minLength: { vi: "Mật khẩu phải có ít nhất 6 ký tự", bn: "পাসওয়ার্ড কমপক্ষে ৬ অক্ষরের হতে হবে" },
        mismatch: { vi: "Mật khẩu xác nhận không khớp", bn: "নিশ্চিতকরণ পাসওয়ার্ড মেলে না" },
        required: { vi: "Vui lòng nhập đầy đủ các trường", bn: "অনুগ্রহ করে সব তথ্য পূরণ করুন" }
      },
      submit: { vi: "Cập nhật mật khẩu", bn: "পাসওয়ার্ড আপডেট করুন" },
      toast: {
        success: { vi: "Đổi mật khẩu thành công!", bn: "পাসওয়ার্ড সফলভাবে পরিবর্তিত হয়েছে!" },
        error: { vi: "Đổi mật khẩu thất bại. Vui lòng kiểm tra lại mật khẩu cũ.", bn: "পাসওয়ার্ড পরিবর্তনে ব্যর্থ হয়েছে৷ অনুগ্রহ করে পুরানো পাসওয়ার্ডটি lại kiểm tra করুন।" }
      }
    },
    comingSoon: { vi: "Tính năng này đang được phát triển", bn: "এই বৈশিষ্ট্যটি বর্তমানে তৈরি করা হচ্ছে" },
    socialAccount: {
      infoTitle: { vi: "Tài khoản liên kết mạng xã hội", bn: "সামাজিক অ্যাকাউন্ট সংযুক্ত" },
      infoDesc: { vi: "Bạn đang đăng nhập bằng **{provider}**. Tài khoản này không sử dụng mật khẩu riêng trên hệ thống HelloJob.", bn: "আপনি **{provider}** ব্যবহার করে সাইন ইন করেছেন। এই অ্যাকাউন্টটি হ্যালোজব সিস্টেমে আলাদা পাসওয়ার্ড ব্যবহার করে না।" },
      manageAction: { vi: "Đi đến cài đặt {provider}", bn: "{provider} সেটিংসে যান" },
      providerNames: { google: "Google", facebook: "Facebook" }
    },
    securityUpgrade: {
      setTitle: { vi: "Thiết lập mật khẩu riêng", bn: "ব্যক্তিগত পাসওয়ার্ড সেট আপ করুন" },
      setSubtitle: { vi: "Bổ sung mật khẩu để có thể đăng nhập bằng email trong tương lai.", bn: "ভবিষ্যতে ইমেল দিয়ে লগইন করার জন্য একটি পাসওয়ার্ড যোগ করুন।" },
      linkedEmailLabel: { vi: "Email liên kết hiện tại", bn: "বর্তমানে সংযুক্ত ইমেল" },
      linkedEmailNote: { vi: "Đây là email từ tài khoản {provider} của bạn. Bạn sẽ dùng email này để đăng nhập cùng mật khẩu mới.", bn: "এটি আপনার {provider} অ্যাকাউন্টের ইমেল। আপনি নতুন পাসওয়ার্ডের সাথে লগইন করতে এই ইমেলটি ব্যবহার করবেন।" },
      setupBenefit: { vi: "Việc đặt mật khẩu giúp bạn chủ động đăng nhập trực tiếp mà không cần phụ thuộc vào mạng xã hội.", bn: "পাসওয়ার্ড সেট করা আপনাকে সামাজিক যোগাযোগ মাধ্যমের ওপর নির্ভর না করেই সরাসরি লগইন করতে সাহায্য করবে।" },
      noEmailTitle: { vi: "Bổ sung Email & Mật khẩu", bn: "ইমেল এবং পাসওয়ার্ড যোগ করুন" },
      noEmailDesc: { vi: "Tài khoản Facebook của bạn chưa có email liên kết. Vui lòng bổ sung để bảo mật tài khoản.", bn: "আপনার ফেসবুক অ্যাকাউন্টে কোনো ইমেল লিঙ্ক করা নেই। অনুগ্রহ করে অ্যাকাউন্টটি সুরক্ষিত করতে একটি ইমেল যোগ করুন।" },
      emailPlaceholder: { vi: "Nhập email thường dùng của bạn", bn: "আপনার নিয়মিত ইমেল লিখুন" }
    }
  }
};
